import {
  createFileRoute,
  useNavigate,
  useParams,
  useSearch,
} from "@tanstack/react-router";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import { PaymentStepper } from "@/features/payments/components/payment-stepper";
import { PaymentSuccess } from "@/features/payments/components/payment-success";

export const Route = createFileRoute(
  "/_authenticated/$company/unternehmen/_fullscreen/bezahlen/fertig",
)({
  component: PaymentsSuccessPage,
  validateSearch: (search: Record<string, unknown>) => ({
    invoiceIds: (search.invoiceIds as string) ?? "",
    navigateBackTo: (search.navigateBackTo as string) ?? "",
  }),
});

function PaymentsSuccessPage() {
  const { company } = useParams({ from: Route.id });
  const { invoiceIds, navigateBackTo } = useSearch({ from: Route.id });
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClose = () => {
    if (navigateBackTo) {
      navigate({ to: `/${company}/unternehmen/${navigateBackTo}` });
    } else {
      navigate({
        to: "/$company/unternehmen/ueberweisungen",
        params: { company },
      });
    }
  };

  return (
    <div className="bg-background flex-1 h-screen overscroll-none">
      <div className="flex flex-row justify-between items-center px-4 py-2">
        <h2 className="text-xl font-semibold">{t("payments.title")}</h2>
        <Button
          variant="ghost"
          onClick={handleClose}
          className="text-muted-foreground gap-2"
        >
          <X />
          {t("payments.close")}
        </Button>
      </div>
      <div className="container mx-auto py-5">
        <PaymentStepper currentStep={3} />
        <PaymentSuccess invoiceIds={invoiceIds ? invoiceIds.split(",") : []} />
        <div className="flex flex-col items-center">
          <Button onClick={handleClose}>{t("payments.close")}</Button>
        </div>
      </div>
    </div>
  );
}
